import queryString from "query-string";

import { SET_MEAL_ORDERS_LIST, SET_UNSETTLED_MEAL_ORDERS_LIST } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getMyOrders = (page, filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/meal-orders?${queryString.stringify({ page, ...filters })}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_MEAL_ORDERS_LIST, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};

export const getTodayOrders = (page, filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/meal-orders/today?${queryString.stringify({ page, ...filters })}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_MEAL_ORDERS_LIST, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};

export const getUnsettledOrders = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/meal-orders/unsettled`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_UNSETTLED_MEAL_ORDERS_LIST, payload: response.data.mealOrders });
    }
    catch (error) { errorHandler(error, null); }
};

export const addMissingMealOrders = (formValues, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/meal-orders/missing`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.push("/meal-orders/today");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const correctMealOrder = (orderID) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/meal-orders/correct/${orderID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, null); }
};